import { render, staticRenderFns } from "./AlgoliaPagination.vue?vue&type=template&id=b185f55c&scoped=true&"
import script from "./AlgoliaPagination.vue?vue&type=script&lang=js&"
export * from "./AlgoliaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b185f55c",
  null
  
)

export default component.exports